import { BrowserModule } from '@angular/platform-browser';
import { Injectable, NgModule } from '@angular/core';


import {SocketIoModule, SocketIoConfig} from 'ngx-socket-io';

import { AppComponent } from './app.component';
import { AuthGuard } from "./shared/guard";
/***
 * Manual imports
 */

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ButtonModule} from 'primeng/button';
import { AppRoutingModule } from './app-routing.module';
import { PagesModule } from './pages/pages.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginModule } from './login/login.module';
import { SocketModule } from './socket/socket.module';


const config : SocketIoConfig = {url:'http://localhost:3000', options:{transports:['websocket', 'polling'], path:'/socket.io/'} };

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ButtonModule,
    AppRoutingModule,
    PagesModule,
    HttpClientModule,
    FormsModule,
    LoginModule, 
    SocketIoModule.forRoot(config)],
  providers: [AuthGuard, SocketModule],
  bootstrap: [AppComponent]
})
export class AppModule { }
